const INITIAL_STATE = {
  listCategoria: [],
  statusEnvio: "",
  statusRemocao: ""
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "CATEGORIA":
      return { ...state, listCategoria: action.payload };
    case "CATEGORIA_ENVIADA":
      return { ...state, statusEnvio: action.payload };
    case "CATEGORIA_REMOVIDA":
      return { ...state, statusRemocao: action.payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/categoria.js